module.exports = __webpack_public_path__ + "img/anna-smc.d675810b.jpg";